import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import React from 'react'
import { Link } from 'react-router-dom'
import { BreadcrumbsPropsModel, BreadcrumsModel } from '../../../Models'
import { CustomTooltip } from '../CustomToolTip/CustomToolTip'

const Breadcrumbs: React.FC<BreadcrumbsPropsModel> = ({ breadcrums, isMarginTop = true }) => {
  const renderLinkElement = (item: BreadcrumsModel, index: number) => (
    <Link
      to={index < breadcrums.length - 1 ? item.path : '#'}
      className={`breadcrums__link ${item.active ? 'active font-bold' : ''}`}
    >
      <div className='d-flex align-items-center justify-content-center'>
        <div className='capitalize' style={{ cursor: 'pointer' }}>
          {item.label}
        </div>{' '}
        {!item.active && (
          <div className='d-flex justify-content-center align-items-center breadCrums__icon'>
            <ChevronRightIcon sx={{ fontSize: '16px' }} />
          </div>
        )}
      </div>
    </Link>
  )

  return (
    <div className={`d-flex align-items-center pr-3 ${isMarginTop && 'breadcrums'}`}>
      {breadcrums.map((item, index) =>
        item?.showTooltip ? (
          <CustomTooltip
            data-testid='tooltip-breadcrums'
            title={item.tooltipText}
            key={`${item.label}-${index}`}
            placement='bottom'
            arrow
          >
            {renderLinkElement(item, index)}
          </CustomTooltip>
        ) : (
          renderLinkElement(item, index)
        ),
      )}
    </div>
  )
}

export default Breadcrumbs
